import React, { createContext, useState } from "react";
import FullPageLoader from "../components/FullPageLoader/FullPageLoader";

export const FullPageLoaderContext = createContext({});

function FullPageLoaderProvider({ children }) {
  const [loading, setLoading] = useState(false);

  return (
    <FullPageLoaderContext.Provider value={{ setFullPageLoading: setLoading }}>
      {children}
      {loading && <FullPageLoader />}
    </FullPageLoaderContext.Provider>
  );
}

export default FullPageLoaderProvider;
